
import { Signal } from './state'

const signals = {
  // common
  resizeEnd: new Signal(),
  doneScroll: new Signal(),

  // scroll
  resetScrollama: new Signal(),
  startingSection: new Signal(),
  progressUpdate: new Signal(),
  endingSection: new Signal(),
  startingSection2: new Signal(),
  progressUpdate2: new Signal(),
  endingSection2: new Signal(),
}

export default signals
